/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

/*
* -------------------------------------------
*                LOAD SURVEY
* -------------------------------------------
*/

export const WIDGET_VOTING_LOAD_SURVEY = '@@b2b_portal_ui/dashboard/widget/WIDGET_VOTING_LOAD_SURVEY';
export const WIDGET_VOTING_LOAD_SURVEY_SUCCESSFUL =
    '@@b2b_portal_ui/dashboard/widget/WIDGET_VOTING_LOAD_SURVEY_SUCCESSFUL';
export const WIDGET_VOTING_LOAD_SURVEY_ERROR = '@@b2b_portal_ui/dashboard/widget/WIDGET_VOTING_LOAD_SURVEY_ERROR';
